import React, { useState } from "react";
import "../styles/styles.css";
import "../../../styles/global.css";
import { icons } from "../../../constants";
import { useTheme } from "../../../utils/ThemeContext";

const PasswordInput = ({
  placeholder,
  label,
  value,
  handleValueChange,
  onKeyDown,
  autoComplete,
  required,
  error,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const { theme } = useTheme();

  const handleChange = (event) => {
    handleValueChange(event.target.value);
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="flex-direction-column items-center gap-8 width-100 height-100 password-input">
      {label && (
        <div className="flex-direction-row items-center width-100 relative">
          {required && (
            <img
              src={icons.required}
              alt="req"
              width={12}
              height={12}
              style={{ position: "absolute", top: "0px", left: "0" }}
            />
          )}
          <label className="width-100 font-12 inria-sans-700">{label}</label>
        </div>
      )}
      <div
        className={`flex-direction-row password-input-container ${
          error ? "invalid" : ""
        }`}
      >
        <input
          type={showPassword ? "text" : "password"}
          className={`inria-sans-300 font-12 `}
          placeholder={placeholder}
          value={value}
          onChange={handleChange}
          onKeyDown={onKeyDown}
          autoComplete={autoComplete}
        />

        <img
          src={
            showPassword
              ? theme === "light"
                ? icons.unlock_password
                : icons.unlock_password_dark
              : theme === "light"
                ? icons.lock_password
                : icons.lock_password_dark
          }
          onClick={togglePasswordVisibility}
          className="pointer"
          alt={showPassword ? "unlock" : "lock"}
        />
      </div>
    </div>
  );
};

export default PasswordInput;
